import { render, staticRenderFns } from "./fade-image.vue?vue&type=template&id=011bbdc6&scoped=true&lang=html"
import script from "./fade-image.vue?vue&type=script&lang=js"
export * from "./fade-image.vue?vue&type=script&lang=js"
import style0 from "./fade-image.vue?vue&type=style&index=0&id=011bbdc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011bbdc6",
  null
  
)

export default component.exports